import { createFileRoute, notFound } from "@tanstack/react-router";
import { getInfluencer, INFLUENCERS } from "@/lib/growth/influencerRegistry";
import { CountryInfluencerPage, CountryInfluencerNotFound } from "@/components/country/shared/CountryInfluencerPage";

export const Route = createFileRoute("/argentina/influencer/$slug")({
  loader: ({ params }) => {
    const inf = getInfluencer(params.slug);
    if (!inf || inf.country !== "AR") throw notFound();
    return inf;
  },
  head: ({ params }) => {
    const inf = INFLUENCERS[params.slug?.toLowerCase() ?? ""];
    const name = inf?.displayName ?? params.slug;
    const url = `https://versesport.com/argentina/influencer/${params.slug}`;
    const title = `Sumate a la comunidad de ${name} — VerseSport Argentina`;
    const desc = `Comunidad ${name} en VerseSport Argentina: pronósticos, ranking y Nation Wars.`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: () => {
    const inf = Route.useLoaderData();
    return <CountryInfluencerPage influencer={inf} backHref="/argentina" backLabel="Volver a VerseSport Argentina" />;
  },
  notFoundComponent: () => <CountryInfluencerNotFound backHref="/argentina" backLabel="Volver a VerseSport Argentina" />,
});